import React from 'react';

import cn from 'classnames';
import { noop } from 'lodash';
import PropTypes from 'prop-types';

import ClickableComponent from 'components/Common/ClickableComponent';
import Text from 'components/Common/Text';

import s from './TextLinkButton.css';

const TextLinkButton = ({
  color,
  onClick,
  children,
  className,
  ...textProps
}) => (
  <Text
    color={color}
    className={cn('textLinkButton', className, {
      [s.blueHover]: color === 'blueDark',
    })}
    component={props => (
      <ClickableComponent {...props} onClick={onClick} tagName="a" />
    )}
    {...textProps}
  >
    {children}
  </Text>
);

TextLinkButton.propTypes = {
  onClick: PropTypes.func,
  color: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

TextLinkButton.defaultProps = {
  onClick: noop,
  className: '',
  color: 'blueDark',
};

export default TextLinkButton;
